import { ModuleId } from '@wix/business-manager-api';

// Note: after submitting PR to BM you can remove the constant strings below
// Note: should be in sync with the config inside your BM module ERB
export const MODULE_ID = ModuleId.MobileTabBm || 'MOBILE_TAB_BM';
export const COMPONENT_ID = 'mobile_tab_bm_component_id';

export const LAZY_COMPONENT_ID = 'mobile_tab_bm';
export const BI_VIEW_ID = 'mobile_tab_bm';

// export const IERBConfig {
//   topology: {
//     staticsUrl: string;
//   };
// };

// export  IBMModuleParams extends TModuleParams {
//   config: IERBConfig;
// }
